import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-14px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "flex gap-y-6 flex-col" }
const _hoisted_3 = { class: "flex flex-col w-3/4" }
const _hoisted_4 = { class: "py-3 w-4/12 mr-4 space-y-4" }
const _hoisted_5 = { class: "py-3 w-4/12 mr-4 space-y-4" }
const _hoisted_6 = { class: "py-3 mr-4 w-3/5 flex flex-row gap-6" }
const _hoisted_7 = { class: "py-3 w-3/5 mr-4 space-y-4" }
const _hoisted_8 = { class: "my-2 capitalize" }
const _hoisted_9 = { class: "py-3 w-full mr-4 space-y-4" }
const _hoisted_10 = { class: "flex flex-row items-center gap-8" }
const _hoisted_11 = { class: "py-3 xxl:text-14px text-black-lp-300" }
const _hoisted_12 = { class: "space-y-2 pt-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Klik tombol dibawah untuk mengaktifkan banner. Anda dapat mengubah status kapan saja. ", -1)
const _hoisted_14 = { class: "flex justify-center gap-4 my-6 w-full ..." }
const _hoisted_15 = { class: "flex justify-end gap-4 w-11/12 ..." }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DatePickers = _resolveComponent("DatePickers")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.pageType === 'update' ? 'Ubah Banner' : 'Buat Banner',
      "vertical-separator": false,
      fullPage: "",
      loading: _ctx.apiDetailData.loading
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _withDirectives(_createVNode("div", _hoisted_4, [
              _createVNode(_component_DataWrapper, { label: "ID Banner" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "text",
                    modelValue: _ctx.detailData.id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.id = $event)),
                    placeholder: "ID Banner",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.pageType === 'update']
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_DataWrapper, { label: "Nama Banner" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "text",
                    modelValue: _ctx.detailData.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.name = $event)),
                    placeholder: "Nama Banner"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                label: "Tanggal Mulai",
                class: "w-6/12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DatePickers, {
                    placeholder: "Tanggal mulai",
                    modelValue: 
                    _ctx.pageType === 'update'
                      ? _ctx.detailData.formatStartDate
                      : _ctx.detailData.startDate
                  ,
                    onSelected: _ctx.setPeriodeStart,
                    minDate: 
                    _ctx.pageType === 'update'
                      ? new Date(_ctx.detailData.createdAt)
                      : new Date()
                  ,
                    class: "my-2",
                    disabled: 
                    _ctx.pageType === 'update' && _ctx.detailData.status === 'active'
                  
                  }, null, 8, ["modelValue", "onSelected", "minDate", "disabled"]),
                  _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.pageType === "update"
                      ? "Tanggal mulai tidak boleh kurang dari tanggal hari ini"
                      : "Tanggal mulai tidak boleh lebih dari tanggal akhir"), 513), [
                    [_vShow, _ctx.invalidStartDate]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Tanggal Berakhir",
                class: "w-6/12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DatePickers, {
                    placeholder: "Tanggal berakhir",
                    modelValue: 
                    _ctx.pageType === 'update'
                      ? _ctx.detailData.formatEndDate
                      : _ctx.detailData.endDate
                  ,
                    onSelected: _ctx.setPeriodeEnd,
                    minDate: new Date(_ctx.detailData.startDate),
                    class: "my-2",
                    disabled: !_ctx.detailData.startDate
                  }, null, 8, ["modelValue", "onSelected", "minDate", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_DataWrapper, { label: "Tambah URL" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "text",
                    modelValue: _ctx.detailData.url,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.url = $event)),
                    placeholder: "URL link (https://example.com)"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Priority",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "number",
                    modelValue: _ctx.detailData.priority,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailData.priority = $event)),
                    placeholder: "Contoh priority : 1",
                    error: _ctx.errorPriority,
                    errorCaption: "Priority tidak boleh atau kurang dari 0",
                    isErrorIconCaption: false
                  }, null, 8, ["modelValue", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, { label: "Target" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_MultipleSelectSearch, {
                      options: _ctx.targetListData,
                      modelValue: _ctx.detailData.target,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailData.target = $event)),
                      modalTitle: "Target",
                      placeholder: "Pilih Target"
                    }, null, 8, ["options", "modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_DataWrapper, { label: "Upload Banner" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_10, [
                    (_ctx.detailData.image)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: _ctx.detailData.image,
                          class: "w-1/2 my-2",
                          alt: "banner-config-image"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_UploadFile, {
                          key: 1,
                          modelValue: _ctx.archiveFile,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.archiveFile = $event)),
                          caption: "JPEG/JPG/PNG",
                          allowed: "image/jpeg, image/jpg, image/png",
                          class: "w-2/3 my-2",
                          maxSize: 0.5,
                          showPreviewImage: "",
                          onChange: _ctx.onFileChange,
                          type: "image",
                          isShowRemarkError: false
                        }, null, 8, ["modelValue", "maxSize", "onChange"])),
                    (_ctx.detailData.image || _ctx.archiveFile)
                      ? (_openBlock(), _createBlock("button", {
                          key: 2,
                          class: "px-6 py-2 xxl:py-2.5 rounded-md border border-gray-lp-500 bg-white text-gray-lp-600",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetImageBanner && _ctx.resetImageBanner(...args)))
                        }, " Ubah foto "))
                      : _createCommentVNode("", true),
                    (_ctx.detailData.image || _ctx.archiveFile)
                      ? (_openBlock(), _createBlock(_component_Icons, {
                          key: 3,
                          name: "delete",
                          class: "cursor-pointer h-8 text-gray-lp-600",
                          onClick: _ctx.resetImageBanner
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", {
                    class: 
                    `w-2/3 my-2 text-12px ${
                      _ctx.isInvalidImage ? 'text-red-lp-1000' : 'text-gray-lp-600'
                    }`
                  
                  }, " Maks. size : 500 KB, Format : jpg, png. Rekomendasi Ukuran 960px X 384px ", 2)
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_DataWrapper, {
                label: "Status",
                class: "my-6"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_Toggle, {
                      onChange: _ctx.onUpdateStatus,
                      modelValue: _ctx.detailData.isActive,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.detailData.isActive = $event)),
                      textActive: "Aktif",
                      textInactive: "Tidak Aktif"
                    }, null, 8, ["onChange", "modelValue"])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_LpButton, {
                class: "pt-6",
                title: "Batal",
                customClass: "w-32",
                onClick: _ctx.goBack,
                outline: "",
                textColor: "red-lp-100"
              }, null, 8, ["onClick"]),
              _createVNode(_component_LpButton, {
                class: "pt-6",
                title: _ctx.pageType === 'update' ? 'Simpan' : 'Upload',
                customClass: "w-32",
                textColor: "white",
                onClick: _ctx.onSubmit,
                disabled: !_ctx.isFormValid
              }, null, 8, ["title", "onClick", "disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.successModalTitle,
      message: _ctx.successModalMessage,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.openSuccess]
    ])
  ]))
}